module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-12.2b0756df.jpg";